module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "dashboard-list"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "dl-th-cover"
  }), _vm._v(" "), _c('th', {
    staticClass: "dl-th-pin"
  }), _vm._v(" "), _c('th', {
    staticClass: "dl-th-name",
    attrs: {
      "aria-sort": _vm.ariaSort('name')
    }
  }, [_c('button', {
    staticClass: "dl-sort",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortBy('name')
      }
    }
  }, [_vm._v("\n                    Name "), (_vm.sort.key === 'name') ? _c('span', {
    staticClass: "dl-arrow"
  }, [_vm._v(_vm._s(_vm.sort.dir === 'asc' ? '▲' : '▼'))]) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "dl-th-date",
    attrs: {
      "aria-sort": _vm.ariaSort('date')
    }
  }, [_c('button', {
    staticClass: "dl-sort",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sortBy('date')
      }
    }
  }, [_vm._v("\n                    Last Updated "), (_vm.sort.key === 'date') ? _c('span', {
    staticClass: "dl-arrow"
  }, [_vm._v(_vm._s(_vm.sort.dir === 'asc' ? '▲' : '▼'))]) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "dl-th-owner"
  }, [_vm._v("Owner")]), _vm._v(" "), _c('th', {
    staticClass: "dl-th-actions"
  })])]), _vm._v(" "), _c('tbody', _vm._l((_vm.projects), function(project) {
    return _c('dashboard-list-row', {
      key: project.id,
      attrs: {
        "project": project
      },
      on: {
        "projectAccepted": function($event) {
          return _vm.$emit('projectAccepted', $event)
        },
        "projectDeleted": function($event) {
          return _vm.$emit('projectDeleted', $event)
        }
      }
    })
  }), 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6ac81a6f","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/dashboard-list.vue
// module id = 1257
// module chunks = 21